module.exports = __webpack_public_path__ + "static/media/bullseye-arrow.89073387.svg";